// hoc/withAdminAuthorization.js
import withAuthorization from './withAuthorization';

const withAdminAuthorization = withAuthorization(['ADMIN', 'BUYER', 'SELLER','TRUCK_REGISTRATION']);
export default withAdminAuthorization;
